import React from 'react';
import FeaturesSection from '../components/FeaturesSection';
import type { Page, CurrentUser } from '../types';

interface DashboardPageProps {
  setActivePage: (page: Page) => void;
  currentUser: CurrentUser;
}

const DashboardPage: React.FC<DashboardPageProps> = ({ setActivePage, currentUser }) => {
  return (
    <div className="flex flex-col h-full">
      <header className="bg-white shadow-md z-10 flex-shrink-0">
        <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <h1 className="text-2xl font-bold text-gray-800">Dashboard</h1>
          </div>
        </div>
      </header>
      <main className="flex-1 overflow-y-auto">
        <div className="py-4">
          <FeaturesSection onFeatureClick={setActivePage} currentUser={currentUser} />
        </div>
      </main>
    </div>
  );
};

export default DashboardPage;